import { currencySymbolSide } from '../../../common/commonConsts';

export function formatPriceFromLocaleInfo(price, localeInfo, options = {}) {
  const { currencySymbol, priceFormat, regionalSettings, currency } = localeInfo;
  let priceString = formatPrice(price, priceFormat, currencySymbol, options);
  if (regionalSettings) {
    const { language, country } = regionalSettings;
    const locale = language + (country ? `-${country}` : '');
    try {
      priceString = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(price);
    } catch (error) {
      console.error(`Error create currency format from regionalSettings`, regionalSettings);
    }
  }

  return priceString;
}

export function formatPrice(price, pricingFoarmat, symbol, options = {}) {
  // https://github.com/wix-private/wix-ecommerce-storemanager/blob/518823f95a7ee7da42bcc17262a49fb5bb9c5967/app/modules/common/filters/formattedCurrencyFilter/formattedCurrencyFilter.ts
  const { noSymbol } = options;

  const format = pricingFoarmat;
  const symbolToUse = noSymbol ? '' : symbol;

  let truncatedString = price.toFixed(format.fractionSize);
  const groupSize = 3;
  const groupSeparationRegex = new RegExp('^(\\d+)(\\d{' + groupSize + '})', '');

  while (format.groupSeparator && truncatedString.match(groupSeparationRegex)) {
    truncatedString = truncatedString.replace(groupSeparationRegex, '$1' + format.groupSeparator + '$2');
  }

  const isPositive = price >= 0 || truncatedString.match(/^0(\.0+)?$/);
  let template;
  if (format.symbolSide === currencySymbolSide.LEFT) {
    template = isPositive ? symbolToUse + truncatedString : '-' + symbolToUse + truncatedString;
  } else {
    template = isPositive ? truncatedString + symbolToUse : '-' + truncatedString + symbolToUse;
  }

  if (format.fractionSize > 0 && format.decimalSeparator !== '.') {
    const decimalSepIndex = template.lastIndexOf('.');
    template = template.substr(0, decimalSepIndex) + format.decimalSeparator + template.substr(decimalSepIndex + 1);
  }

  return template;
}
